import { z } from "zod";

export const protocolQuestionFormDataSchema = z.object({
  protocol_question_id: z.number().optional(),
  name: z.string(),
  content: z.string(),
  theme: z.number(),
  sub_theme: z.number(),
  scope_of_applicability: z.array(z.number()),
  stakeholder_engagement: z.boolean(),
  internal_audit: z.boolean(),
  erm_mapping_note: z.string().optional(),
  internal_note: z.string().optional(),
});

export type ProtocolQuestionFormData = z.infer<typeof protocolQuestionFormDataSchema>;
